import { Label, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import MDAFilter from "pages/Payments/MDAFilter";
import RegionFilter from "pages/Payments/RegionFilter";

const OffCanvasFilter = ({
  show,
  onCloseClick,
  setFilterValue,
  filterValue,
  setPage,
  setSearchValue,
  searchValue,
  clearFilters,
}: any) => {
  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      id="offcanvasRight"
      toggle={onCloseClick}
    >
      <OffcanvasHeader className="bg-light" toggle={onCloseClick}>
        Payment Filters
      </OffcanvasHeader>
      <form
        action=""
        className="d-flex flex-column justify-content-end h-100"
        onSubmit={(e) => {
          e.preventDefault();
          onCloseClick();
        }}
      >
        <OffcanvasBody>
          <div className="mb-4">
            <Label
              htmlFor="datepicker-range"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Search
            </Label>
            {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
            <div className="search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search payments..."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(1);
                }}
                value={searchValue}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </div>
          {/* <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Status
            </Label>
            <select
              className="form-control"
              data-choices
              data-choices-search-false
              name="choices-single-default2"
              id="choices-single-default2"
              onChange={(e: any) => {
                setFilterValue({
                  ...filterValue,
                  status: e.target.value,
                });
                setPage(1);
              }}
              value={filterValue.status}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div> */}
          <div className="mb-4">
            <Label
              htmlFor="region-field"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Region (FMS/FGS)
            </Label>
            <RegionFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, region: value });
                setPage(1);
              }}
              value={filterValue.region}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              MDA
            </Label>
            <MDAFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, mda: value });
                setPage(1);
              }}
              value={filterValue.mda}
              regionId={filterValue.region?.value || ""}
            />
          </div>
        </OffcanvasBody>
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <button
            className="btn btn-light w-100"
            onClick={(e) => {
              e.preventDefault();
              clearFilters();
            }}
          >
            Clear Filter
          </button>
          <button
            type="submit"
            className="btn btn-success w-100"
            onClick={onCloseClick}
          >
            Submit
          </button>
        </div>
      </form>
    </Offcanvas>
  );
};

export default OffCanvasFilter;
